import React from 'react';
import ReactDropZone from 'react-dropzone';
import classes from './Dropzone.module.scss';

const Dropzone = ({ ...props }, ref) => {
  return <ReactDropZone ref={ref} className={classes.dropzone} {...props} />;
};

export default React.forwardRef(Dropzone);
